import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Tab } from "@mui/material";
import { OrionTransactionsList } from "components/transactions/OrionTransactionsList";
import { TransactionsList } from "components/transactions/TransactionsList";
import Layout from "components/Layout";
import { useState } from "react";

type TransactionsTab = "imported" | "orion";

// Imported reads the local orion_transactions table; Orion reads Orion's API
// live. Each panel mounts only while shown, so the Orion tab costs no Orion
// call until it is opened.
export const TransactionsPage = () => {
  const [tab, setTab] = useState<TransactionsTab>("imported");

  return (
    <Layout title="Transactions" content="Transactions page">
      <TabContext value={tab}>
        <Box borderBottom={1} borderColor="divider">
          <TabList
            onChange={(_event, value: TransactionsTab) => setTab(value)}
            aria-label="transactions tabs"
          >
            <Tab label="Imported" value="imported" />
            <Tab label="Orion" value="orion" />
          </TabList>
        </Box>
        <TabPanel value="imported" sx={{ paddingX: 0 }}>
          <TransactionsList />
        </TabPanel>
        <TabPanel value="orion" sx={{ paddingX: 0 }}>
          <OrionTransactionsList />
        </TabPanel>
      </TabContext>
    </Layout>
  );
};
